export function GroupBadges({ names }) {
  if (!names?.length) {
    return <span className="muted-text">—</span>; // no groups
  }

  return (
    <div className="flex flex-wrap gap-1 items-center justify-center">
      {names.map((g) => (
        <span
          key={g}
          className="inline-block bg-primary/10 text-primary
                     text-[11px] px-2 py-[2px] rounded-full truncate max-w-[8rem]"
          title={g} // full name on hover
        >
          {g}
        </span>
      ))}
    </div>
  );
}
